import {
  FlowHumanTaskBlockWorkContextContentType,
  type FlowHumanTaskStep,
  type FlowHumanTaskSubtask,
} from 'flow-schema';
import * as uuid from 'uuid';

import { type api } from 'common';

import { HumanTaskFieldType, getDefaultHumanTaskFieldConfig } from './Fields/AllFields';

export function getDefaultHumanTaskStepConfig(): FlowHumanTaskStep {
  return {
    id: uuid.v4(),
    title: '',
    fields: [getDefaultHumanTaskFieldConfig(HumanTaskFieldType.ContentMarkdown)],
  };
}

export function getDefaultHumanTaskWorkContextConfig(): api.FlowDefinition.HumanTaskBlock['config']['workContexts'][0] {
  return {
    id: uuid.v4(),
    contentType: FlowHumanTaskBlockWorkContextContentType.Markdown,
    markdownContent: '',
  };
}

export function getDefaultHumanTaskCustomSubtaskConfig(): FlowHumanTaskSubtask {
  return {
    id: uuid.v4(),
    name: 'Default Subtask',
    steps: [getDefaultHumanTaskStepConfig()],
  };
}
